<template>

  <!-- الگوی Facade: تا قبل از کلیک فقط تصویر بندانگشتی سبک لود می‌شود؛
       iframe سنگین (حدود ۱ مگابایت جاوااسکریپت هر پلیر) فقط با خواست کاربر -->
  <div class="lite-player" :class="{ 'is-playing': playing }">

    <template v-if="!playing">
      <button
          class="facade"
          type="button"
          :aria-label="`پخش ویدئو: ${title}`"
          @click="play"
      >
        <img
            v-if="thumbnailUrl"
            :src="thumbnailUrl"
            :alt="title"
            loading="lazy"
        >
        <div v-else class="no-thumb"></div>
        <span class="play-btn">▶</span>
        <span v-if="providerLabel" class="provider-badge">{{ providerLabel }}</span>
      </button>
    </template>

    <template v-else>
      <iframe
          v-if="finalEmbedUrl"
          :src="finalEmbedUrl"
          :title="title"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          allowfullscreen
          frameborder="0"
      ></iframe>
      <div v-else class="no-embed">
        <p>پخش‌کنندهٔ این ویدئو در دسترس نیست.</p>
        <a
            v-if="pageUrl"
            :href="pageUrl"
            target="_blank"
            rel="noopener"
        >تماشا در منبع اصلی ↗</a>
      </div>
    </template>

  </div>

</template>

<script>

/**
 * LiteVideoPlayer — پخش‌کنندهٔ چند-provider با لود تنبل
 * provider: aparat | youtube | cf_stream
 */
const PROVIDERS = {
  aparat: {
    label: 'آپارات',
    embed: id => `https://www.aparat.com/video/video/embed/videohash/${id}/vt/frame`,
    page: id => `https://www.aparat.com/v/${id}`,
  },
  youtube: {
    label: 'یوتیوب',
    embed: id => `https://www.youtube-nocookie.com/embed/${id}?rel=0&autoplay=1`,
    page: id => `https://www.youtube.com/watch?v=${id}`,
  },
  cf_stream: {
    label: 'Cloudflare Stream',
    embed: id => {
      // شناسهٔ customer در build از env فرانت تزریق می‌شود (فاز ۲)
      const cust = (process.env.VUE_APP_CF_STREAM_CUSTOMER || '')
      return cust ? `https://customer-${cust}.cloudflarestream.com/${id}/iframe?autoplay=true` : null
    },
    page: () => '#',
  },
}

export default {

  name: 'LiteVideoPlayer',

  props: {
    provider: { type: String, required: true },
    externalId: { type: String, required: true },
    thumbnailUrl: { type: String, default: '' },
    title: { type: String, default: '' },
  },

  data() {
    return {
      playing: false,
    }
  },

  computed: {
    p() {
      return PROVIDERS[this.provider] || null
    },
    providerLabel() {
      return this.p ? this.p.label : ''
    },
    finalEmbedUrl() {
      return this.p ? (this.p.embed(this.externalId) || null) : null
    },
    pageUrl() {
      return this.p ? (this.p.page(this.externalId) || null) : null
    },
  },

  methods: {
    play() {
      this.playing = true
      this.$emit('play')
    },
  },

}

</script>

<style scoped lang="scss">

.lite-player {
  width: 100%;
  border-radius: 14px;
  overflow: hidden;
  background: #04140f;
  box-shadow: 0 12px 28px rgba(0, 0, 0, .18);
}

.facade {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  padding: 0;
  border: 0;
  cursor: pointer;
  background: transparent;

  img,
  .no-thumb {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .no-thumb {
    background: linear-gradient(135deg, #022c22 0%, #064e3b 45%, #047857 85%, #059669 100%);
  }

  .play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: rgba(15, 118, 110, .95);
    color: #fff;
    font-size: 1.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 4px; // وسط‌چینی بصری مثلث
    box-shadow: 0 8px 24px rgba(0, 0, 0, .35);
    transition: transform .2s ease, background .2s ease;

    @media (hover: hover) {
      .facade:hover & {
        transform: translate(-50%, -50%) scale(1.08);
        background: #0d9488;
      }
    }
  }

  .provider-badge {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(0, 0, 0, .6);
    color: #fff;
    font-size: 0.72rem;
    padding: 3px 10px;
    border-radius: 999px;
  }
}

iframe {
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  border: 0;
}

.no-embed {
  aspect-ratio: 16 / 9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #cbd5e1;

  a {
    color: #5eead4;
    font-weight: 700;
    text-decoration: none;
  }
}

</style>
